<template>
  <div class="OperateSee">

    <van-button @click="QRCode" type="info" block >查询</van-button>

    <div class="OperateSee-main" v-if="detail.status !== null" >

      <div class="OperateSee-main-title">
        查询结果
      </div>

      <template>

        <div class="OperateSee-main-fail" v-if="detail.status === 0" >
          <img src="../../assets/TestKit/SeeFail.png" alt="">
          <h2>查询失败</h2>
          <p>未查到您的检测记录</p>
        </div>

        <ul class="OperateSee-main-ul" v-else>
          <li>
            <p>姓名</p>
            <p>{{ detail.name }}</p>
          </li>
          <li>
            <p>性别</p>
            <p>{{ detail.gender === 0 ? "女" : "男" }}</p>
          </li>
          <li>
            <p>年龄</p>
            <p>{{ detail.age + "岁" }}</p>
          </li>
          <li>
            <p>身份证号</p>
            <p>{{ detail.idCardNo }}</p>
          </li>
          <li>
            <p>受检人手机号</p>
            <p>{{ detail.phoneNoOne }}</p>
          </li>
          <li>
            <p>试剂盒编号</p>
            <p>{{ detail.reagentNo }}</p>
          </li>
          <li :style="{'color': detail.recoverDate ? 'red' : ''}">
            <p>回收日期</p>
            <p>{{ detail.recoverDate ? detail.recoverDate : "--" }}</p>
          </li>
          <li>
            <van-button @click="recovery(detail.reagentId)" type="primary" >回收</van-button>
          </li>
        </ul>

      </template>

    </div>

  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { Button } from "vant";

export default {
  name: "OperateSee",
  data() {
    return {
      reagentNo: null,
      detail: {
        status: null
      }
    }
  },
  created() {
    if(this.$route.query.code) {
      this.sentCode(this.$route.query.code);
    }else {
      this.authorization();
    }
  },
  methods: {
    // 查询
    QRCode() {
      this.detail= {
        status: null
      }
      let that= this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          setTimeout(() => {
            let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            let index = result.indexOf(",") + 1;
            if(index) {
              that.reagentNo= result.substring(index);
            }else {
              that.reagentNo= result;
            }

            that.$get("reagent/operation",that.reagentNo,true)
              .then(res => {
                console.log(res);
                that.detail= res.data;
              })

          },1000)
        }
      });
    },
    recovery(e) {
      this.$get("reagent/operation/recoverDate",e,true)
          .then(res => {
            if(res) {
              this.$get("reagent/operation",this.detail.reagentNo,true)
                  .then(res => {
                    this.detail= res.data;
                  })
            }
          })
    },
    // 微信授权code
    sentCode(e) {
      this.$get("wx/userAuth",{code : e})
          .then(res => {
            console.log(res);
          })
    },
    // 微信授权
    authorization() {
      let url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?" +
          "appid=" + process.env.VUE_APP_AppID +
          "&redirect_uri=" + process.env.VUE_APP_WxUrl + "/OperateSee" +
          "&response_type=code&scope=snsapi_userinfo&state=" + '0' + "#wechat_redirect";
      // 访问微信API
      window.location.href = url;
    },
  },components: {
    [Button.name]: Button,
  }
}
</script>

<style lang="scss" scoped>
 @import "../../style/OperateSee/OperateSee";
</style>
